import { useState, useEffect, useCallback } from 'react';
import { adminSelectionService } from '../service/adminSelectionService.mjs';
import { secureLogger } from '../../utils/secureLogger.mjs';



export const useAdminSelection = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadProfile = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            
            const response = await adminSelectionService.getProfile();
            
            if (response.success) {
             
                setCurrentUser(response.data.admin);
            } else {
              
                setError('Failed to load profile');
            }
        } catch (err) {
            secureLogger.error('Error loading profile', { status: err.response?.status });

            if (err.response?.status === 403) {
                const errorData = err.response.data;
                setError(`Access denied: ${errorData.message}. Your role: ${errorData.userRole}`);
            } else if (err.response?.status === 401) {
                window.location.href = '/login';
            } else {
                setError(err.response?.data?.message || 'Failed to load profile');
            }
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadProfile();
    }, [loadProfile]);

    return {
        currentUser,
        loading,
        error,
        refetch: loadProfile
    };
};


